const _loadScript = (
  source,
  beforeEl,
  async = true,
  defer = true,
  integrity = null
) => {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    const prior = beforeEl || document.getElementsByTagName('script')[0];

    script.async = async;
    script.defer = defer;

    if (integrity) {
      script.integrity = integrity;
      script.crossOrigin = 'anonymous';
    }

    const onloadHandler = (_, isAbort) => {
      if (
        isAbort ||
        !script.readyState ||
        /loaded|complete/.test(script.readyState)
      ) {
        script.onload = null;
        script.onreadystatechange = null;
        script = undefined;

        if (isAbort) {
          reject();
        } else {
          resolve();
        }
      }
    };
    const onerrorHandler = (oError, a) => {
      reject(`The script ${oError.target.src} didn't load correctly.`);
    };

    script.onload = onloadHandler;
    script.onerror = onerrorHandler;
    script.onreadystatechange = onloadHandler;
    script.src = source;
    prior.parentNode.insertBefore(script, prior);
  });
};

export const loadScript = script => _loadScript(script);
export const loadScriptsList = async scriptsList => {
  for (const script of scriptsList) {
    try {
      await _loadScript(script);
    } catch (e) {
      return Promise.reject(e);
    }
  }
  return Promise.resolve();
};

export const safeLoadScriptsList = async scriptsList => {
  for (const script of scriptsList) {
    try {
      if (script.name) {
        await _loadScript(script.name, null, true, true, script.integrity);
      }
    } catch (e) {
      return Promise.reject(e);
    }
  }
  return Promise.resolve();
};
